export default {
  toggleMenu(state) {
    state.menuIsOpen = !state.menuIsOpen;
  },
};